export default (state, { customerProductId }) => (
  state.userGroups
  && state.userGroups.data
  && state.userGroups.data[customerProductId]
  && state.userGroups.data[customerProductId].userGroups
  && Object.values(state.userGroups.data[customerProductId].userGroups)
) || []
